$(document).ready(function(){


   // resize the slide-read-more Div
   var box = $(".slide-read-more");
   var minimumHeight = 120; // max height in pixels
   var initialHeight = box.innerHeight();
   // reduce the text if it's longer than 200px
   if (initialHeight > minimumHeight) {
      box.css('height', minimumHeight);
      $(".read-more-button").show();
   } else {
     $(".read-more-button").hide();
   }
  
   SliderReadMore();

   function SliderReadMore() {
      $(".slide-read-more-button").on('click', function () {
         // get current height
         var currentHeight = box.innerHeight();

         // get height with auto applied
         var autoHeight = box.css('height', 'auto').innerHeight();

         // reset height and revert to original if current and auto are equal
         var newHeight = (currentHeight | 0) === (autoHeight | 0) ? minimumHeight : autoHeight;

         box.css('height', currentHeight).animate({
            height: (newHeight)
         })
         $('html, body').animate({
          //  scrollTop: box.offset().top
         });
        $(".slide-read-more-button").toggle('fast');
      });
   }



  /*
     function AddReadMore() {
      //This limit you can set after how much characters you want to show Read More.
      var carLmt = 178;
      // Text to show when text is collapsed
      var readMoreTxt = "... <em>Read more</em>";
      // Text to show when text is expanded
      var readLessTxt = " <em>Read less</em>";

      //Traverse all selectors with this class and manupulate HTML part to show Read More
      $(".add-read-more").each(function () {
         if ($(this).find(".first-section").length)
            return;

         var allstr = $(this).html();
         if (allstr.length > carLmt) {
            var firstSet = allstr.substring(0, carLmt);
            var secdHalf = allstr.substring(carLmt, allstr.length);
            var strtoadd = firstSet + "<span class='second-section'>" + secdHalf + "</span><span class='read-more'  title='Click to Show More'>" + readMoreTxt + "</span><span class='read-less' title='Click to Show Less'>" + readLessTxt + "</span>";
            $(this).html(strtoadd);
         }
      });

      //Read More and Read Less Click Event binding
      $(document).on("click", ".read-more,.read-less", function () {
         $(this).closest(".add-read-more").toggleClass("show-less-content show-more-content");
      });
   }

   AddReadMore();
*/

$('body').on('click', '.title_h3', function(e) {
    $('.box-a1').find('.level-box').stop().slideUp('fast');
    $(this).closest('.box-a1').find('.level-box').stop().slideToggle('fast');
  $('.title_h3').not(this).removeClass('active');
   $(this).toggleClass('active');  
});


$('body').on('click', '.open_studies', function(e) {
  $(this).toggleClass('active');
  $(this).next('.studies_box').slideToggle('fast');   
});
  
  
  
$('body').on('click', '.pdp-Ingredients_heading', function(e) {
  /*
  $('.pdp-Ingredient_row').slideToggle('fast');
   $(this).toggleClass('active');  




var $swiperSelectorss = $('#swiper-container_3');
$swiperSelectorss.each(function (index) {
  var $this = $(this);
  $this.addClass('swiper-sliderss-' + index);

  var dragSize = $this.data('drag-size') ? $this.data('drag-size') : 180;
  var freeMode = $this.data('free-mode') ? $this.data('free-mode') : false;
  var loop = $this.data('loop') ? $this.data('loop') : false;
  var slidesDesktop = $this.data('slides-desktop') ? $this.data('slides-desktop') : 4;
  var slidesLap = $this.data('slides-Lap') ? $this.data('slides-lap') : 4;
  var slidesTablet = $this.data('slides-tablet') ? $this.data('slides-tablet') : 3;
  var slidesMobile = $this.data('slides-mobile') ? $this.data('slides-mobile') : 3;
  var spaceBetween = $this.data('space-between') ? $this.data('space-between') : -2;
  var swipers = new Swiper('.swiper-sliderss-' + index, {
    direction: 'horizontal',
    loop: loop,
    freeMode: freeMode,
    spaceBetween: spaceBetween,
    breakpoints: {
      1920: {
        slidesPerView: slidesDesktop },

      1150: {
        slidesPerView: slidesLap },

      992: {
        slidesPerView: slidesTablet },

      767: {
        slidesPerView: slidesMobile } },

    navigation: {
      nextEl: '.swiper-button-next_3',
      prevEl: '.swiper-button-prev_3' },

    scrollbar: {
      el: '.swiper-scrollbar_3',
      draggable: true,
      dragSize: dragSize } });
});*/
//# sourceURL=pen.js

});


$(".vsize_1").clone().appendTo(".radio__button_1 .option-title");
$(".vsize_2").clone().appendTo(".radio__button_2 .option-title");
$(".vsize_3").clone().appendTo(".radio__button_3 .option-title");
$(".vsize_4").clone().appendTo(".radio__button_4 .option-title");
$(".vsize_5").clone().appendTo(".radio__button_5 .option-title");
$(".vsize_6").clone().appendTo(".radio__button_6 .option-title");

  $(".radio__button input:checked + label  div").clone().appendTo(".product__price__wrap");
  

  
$('body').on('click', '.radio__button label', function(e) {
  var sizetext = $(this).find('div').html();
   
  $('.product__price__wrap .vsizebox').html(sizetext);
     
});


  
$('body').on('click', '.up_tab_1', function(e) { 
   $('.product__upsell_1').show();
   $('.bundle_section').hide();
   $('.product__set').hide();
  $(this).addClass('active');
  $('.up_tab_2').removeClass('active'); 
  $('.up_tab_3').removeClass('active');   
});

$('body').on('click', '.up_tab_2', function(e) { 
  $('.bundle_section').show();
  $('.product__upsell_1').hide();
   $('.product__set').hide();
  $(this).addClass('active');
  $('.up_tab_1').removeClass('active');  
   $('.up_tab_3').removeClass('active');   
});

  $('body').on('click', '.up_tab_3', function(e) { 
  $('.bundle_section').hide();
  $('.product__upsell_1').hide();
   $('.product__set').show();
  $(this).addClass('active');
  $('.up_tab_1').removeClass('active');  
   $('.up_tab_2').removeClass('active');   
});




  

  
});

$(window).on('load', function(){
  setTimeout(function() {
  $(".shop-pay-terms").css('opacity', '1');    
    }, 2500);

    setTimeout(function() {  
    $(".product__page").css('opacity', '1');
    }, 200);
});


$(document).ready(function() {
   $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    asNavFor: '.slider-nav',
     responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        centerPadding: '0px',
        centerMode: true,
         arrows: true,
        dots:true
      }
    }
    ]
});
$('.slider-nav').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    vertical:true,
    asNavFor: '.slider-for',
    dots: false,
    focusOnSelect: true,
    verticalSwiping:true,
    responsive: [
    {
        breakpoint: 991,
        settings: {
         slidesToShow: 8,
        }
    },
    {
      breakpoint: 767,
      settings: {
        vertical: false,
      }
    }
    ]
});

  //by sd
function playActiveVideo(){
        // Pause all videos first
        $('.video').each(function(){
            this.pause();
            this.currentTime = 0; // Reset video to start
        });

        // Get the active slide's video and play it
        var $currentSlide = $('.slider .slick-current');
        var $video = $currentSlide.find('.deferred-media');

        if ($video.length > 0) {
            //alert('1');
            $currentSlide.find('.deferred-media__poster').trigger('click');
        } else {
           $("video").each(function() {
            $(this).get(0).pause();
          })
        }
    }

    // Play video on slide change
    $('.slider-for').on('afterChange', function(){
        playActiveVideo();
    });

    // Play video on first slide load
    playActiveVideo();  
  

});



